import shared, { SHARED_MOBILE_PAGES } from "./shared";
import vbsus from "./vbsus";
import mx from "./mx";
import eds from "./eds";

/** @type {Record<string, import('./types').MobileTenantModule>} */
export const MOBILE_TENANTS = {
  vbsus,
  mx,
  eds,
};

/**
 * Resolve a mobile page component for the active storefront tenant.
 * Falls back to shared defaults when a tenant has no override.
 *
 * @param {string | null | undefined} tenantKey
 * @param {import('./types').MobilePageKey} pageName
 */
export function resolveMobilePage(tenantKey, pageName) {
  const key = String(tenantKey || "")
    .trim()
    .toLowerCase();
  const tenant = MOBILE_TENANTS[key];
  return tenant?.pages?.[pageName] || SHARED_MOBILE_PAGES[pageName] || null;
}

export function getMobileTenantModule(tenantKey) {
  const key = String(tenantKey || "")
    .trim()
    .toLowerCase();
  return MOBILE_TENANTS[key] || null;
}

export function listMobileTenants() {
  return Object.values(MOBILE_TENANTS);
}

export { shared };
